import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import LandingLayout from 'components/features/LandingLayout';
import BrowserWarning from 'components/features/BrowserWarning';
import AuthError from 'components/features/AuthError';

function ErrorPage() {
  const { path } = useRouteMatch();

  return (
    <LandingLayout>
      <Switch>
        <Route path={`${path}/authentication-failed`}>
          <AuthError />
        </Route>
        <Route path={`${path}/unsupported-browser`}>
          <BrowserWarning />
        </Route>
        <Route path="*">
          <p>Error</p>
        </Route>
      </Switch>
    </LandingLayout>
  );
}

export default ErrorPage;
